import { getFirestore, getDoc, doc } from "firebase/firestore";
import { app } from "../config"


// const auth = getAuth(app);
const db = getFirestore(app);

// Define the function to display the MPS_BusinessProfiles document
const displayMPSProfile = async (documentId) => {
  try {
    // Reference the document by ID
    const docRef = doc(db, "MPS_BusinessProfiles", documentId);

    // Fetch the document
    const docSnap = await getDoc(docRef);

    // Check if the document exists and display the data
    if (docSnap.exists()) {
      const data = docSnap.data();
      // console.log("Document data:", data)
      return data; // You can return the data if you want to use it elsewhere
    } else {
      console.log("No such document!");
    }
  } catch (error) {
    console.error("Error fetching document: ", error);
  }
};

export { displayMPSProfile };
